import { QrScanner } from '@yudiel/react-qr-scanner';
import { useRef, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import styles from '../../css/admin/Verification.module.css';
import Navbar from '../admin/NavBar';

export default function Verification() {
  const navigate = useNavigate();
  const { storeNo } = useParams();
  const isNavigatingRef = useRef(false);
  const [preferredDeviceId, setPreferredDeviceId] = useState();
  const [torchOn, setTorchOn] = useState(false);

  useEffect(() => {
    let isCancelled = false;

    const chooseBackCamera = async () => {
      try {
        if (
          !navigator.mediaDevices ||
          !navigator.mediaDevices.enumerateDevices
        ) {
          return;
        }
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter(d => d.kind === 'videoinput');
        if (videoInputs.length === 0) return;

        const priorityMatchers = [
          /back/i,
          /rear/i,
          /environment/i,
          /wide/i,
          /tele/i,
          /main/i,
        ];
        let picked = null;
        for (const re of priorityMatchers) {
          picked = videoInputs.find(d => re.test(d.label));
          if (picked) break;
        }
        if (!picked) picked = videoInputs[videoInputs.length - 1];
        if (!isCancelled && picked) setPreferredDeviceId(picked.deviceId);
      } catch (e) {
        // ignore; will fall back to facingMode constraint
      }
    };

    chooseBackCamera();

    return () => {
      isCancelled = true;
    };
  }, []);

  const handleDecode = text => {
    if (!text || isNavigatingRef.current) return;
    const clean = text.split('?')[0].split('#')[0].replace(/\/+$/, '');
    const parts = clean.split('/').filter(Boolean);

    const nums = [];
    for (let i = parts.length - 1; i >= 0 && nums.length < 2; i--) {
      if (/^\d+$/.test(parts[i])) nums.push(parts[i]);
    }
    nums.reverse();

    if (nums.length === 2) {
      const [memberGiftNoFromQR, giftNoFromQR] = nums;
      isNavigatingRef.current = true;
      navigate(
        `/mobile/verifyconfirm/${storeNo}/${memberGiftNoFromQR}/${giftNoFromQR}`
      );
    } else if (parts.length >= 1) {
      const id = parts[parts.length - 1];
      isNavigatingRef.current = true;
      navigate(`/mobile/verifyconfirm/${storeNo}/${id}`);
    } else {
      window.alert('QR 형식이 올바르지 않습니다. 다시 시도해주세요.');
    }
  };

  // 카메라 에러 핸들러 (경고창으로 안내)
  const handleCameraError = error => {
    console.error('카메라 접근 에러:', error);
    if (error && error.name === 'NotAllowedError') {
      window.alert(
        '카메라 접근이 차단되었습니다. 브라우저 설정에서 카메라 권한을 허용해주세요.'
      );
    } else if (
      error &&
      (error.name === 'NotFoundError' ||
        error.message?.toLowerCase().includes('no camera'))
    ) {
      window.alert('카메라를 찾을 수 없습니다. 다른 기기를 사용해보세요.');
    } else if (error && error.name === 'OverconstrainedError') {
      window.alert(
        '후면 카메라를 사용할 수 없습니다. 기기 설정을 확인하거나 다른 카메라를 시도해주세요.'
      );
    } else if (error && error.name === 'NotReadableError') {
      window.alert(
        '카메라를 사용할 수 없습니다. 다른 앱에서 사용 중인지 확인하세요.'
      );
    } else if (error) {
      window.alert(
        '카메라를 사용할 수 없습니다. 다른 기기나 브라우저를 시도해보세요.'
      );
    }
  };

  return (
    <>
      <Navbar />
      <div className={styles.cameraContainer}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 8,
          }}
        >
          <button onClick={() => setTorchOn(v => !v)}>
            플래시 {torchOn ? '끄기' : '켜기'}
          </button>
        </div>
        <QrScanner
          constraints={{
            ...(preferredDeviceId
              ? { deviceId: { exact: preferredDeviceId } }
              : {}),
            facingMode: { ideal: 'environment' },
            width: { ideal: 1920 },
            height: { ideal: 1080 },
            advanced: [
              { focusMode: 'continuous' },
              ...(torchOn ? [{ torch: true }] : []),
            ],
          }}
          scanDelay={300}
          onDecode={handleDecode}
          onError={handleCameraError}
        />
      </div>
    </>
  );
}
